import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { searchRedirectActionRoute } from '@townsquare/routes/search-redirect-action';

import { SearchRedirectAction } from './loadable';

searchRedirectActionRoute.component = SearchRedirectAction;
export const searchRedirectActionRouterRoute: GlobalHomePageRoute = searchRedirectActionRoute;
